import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mobile-confirm-section" }
const _hoisted_2 = { class: "mobile-confirm-header" }
const _hoisted_3 = { class: "mobile-confirm-title" }
const _hoisted_4 = {
  key: 0,
  class: "mobile-no-entries"
}
const _hoisted_5 = {
  key: 1,
  class: "mobile-lines-section"
}
const _hoisted_6 = { class: "mobile-lines-header" }
const _hoisted_7 = { class: "mobile-lines-list" }
const _hoisted_8 = { class: "mobile-line-content" }
const _hoisted_9 = { class: "mobile-line-numbers" }
const _hoisted_10 = { class: "mobile-line-balls" }
const _hoisted_11 = {
  key: 0,
  class: "mobile-line-bonus"
}
const _hoisted_12 = { class: "mobile-line-bonus-ball" }
const _hoisted_13 = { class: "mobile-line-odds" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["disabled"]


import { formatOdds } from '../../utils/currency';


const __default__ = {
  name: "MobileConfirmSection",
};

interface MarketOutcome {
  outcome_id: number;
  text: string;
  select_numbers: boolean;
  pick: number;
  slug: string;
  odds: string;
}

interface Market {
  market_id: number;
  market_name: string;
  outcomes: MarketOutcome[];
}

interface Line {
  numbers: number[];
  bonus?: number;
  market?: {
    marketGroup?: {
      slug: string;
    };
    market: Market;
  };
}

interface Props {
  lines: Line[];
  currentGameSlug?: string;
  selectedRelatedGames?: string[];
  isProcessing?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    lines: {},
    currentGameSlug: {},
    selectedRelatedGames: { default: () => [] },
    isProcessing: { type: Boolean, default: false }
  },
  emits: ["clear-all", "remove-line", "add-to-betslip", "update:selectedRelatedGames"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const clearAll = () => {
  emit('clear-all');
};

const removeLine = (index: number) => {
  emit('remove-line', index);
};

const addToBetslip = () => {
  emit('add-to-betslip');
};

const getLineOdds = (line: Line): string => {
  if (!line.market?.market.outcomes) {
    return '1.00';
  }
  
  const numberCount = line.numbers.length;
  const outcome = line.market.market.outcomes.find(
    (outcome: MarketOutcome) => outcome.select_numbers && outcome.pick === numberCount
  );
  
  return outcome ? formatOdds(Number(outcome.odds)) : '1.00';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, "3. " + _toDisplayString(_ctx.$t('detail.confirmEntries')), 1)
    ]),
    (_ctx.lines.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('detail.noEntriesYet')), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('detail.yourEntries')) + " (" + _toDisplayString(_ctx.lines.length) + ")", 1),
            _createElementVNode("button", {
              class: "mobile-clear-btn",
              onClick: clearAll
            }, _toDisplayString(_ctx.$t('common.clearAll')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "mobile-line-item"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.numbers, (number) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: number,
                          class: "mobile-line-ball"
                        }, _toDisplayString(number), 1))
                      }), 128)),
                      (line.bonus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mobile-line-bonus-separator" }, "+", -1)),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(line.bonus), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(getLineOdds(line)), 1)
                ]),
                _createElementVNode("button", {
                  class: "mobile-remove-line-btn",
                  onClick: ($event: any) => (removeLine(index))
                }, " × ", 8, _hoisted_14)
              ]))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "mobile-add-to-betslip-btn",
            onClick: addToBetslip,
            disabled: _ctx.lines.length === 0 || _ctx.isProcessing
          }, _toDisplayString(_ctx.$t('detail.addToBetslip')), 9, _hoisted_15)
        ]))
  ]))
}
}

})